import { Button, Stack, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

export const CareerFaqBanner = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return <Stack direction={'column'}
        justifyContent={'center'}
        alignItems={'center'}
        padding={5}
        sx={{ backgroundColor: "#00FF4222" }}>
        <Typography textAlign={'center'} fontWeight={'bold'}>{t('careers.learnMore.title')}</Typography>
        <Typography textAlign={'center'}>{t('careers.learnMore.content')}</Typography>
        <Button variant="contained" onClick={() => navigate("/faq")}>{t('careers.learnMore.actionBtn')}</Button>
    </Stack>
}